<div
    role="status"
    class="rounded p-4 md:p-6 mb-4 space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
    <div class="w-full">
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[480px] mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[480px] mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[480px] mb-2.5"></div>
    </div>
    <div class="animate-pulse">
        <div
            class="hidden md:flex items-center justify-center w-[150px] h-[150px] p-1 animate-pulse"
            [ngClass]="{
                'bg-white': !darkMode,
                'bg-gray-950': darkMode,
                'text-white': darkMode,
                'text-black': !darkMode,
            }"></div>
    </div>
    <span class="sr-only">Loading...</span>
</div>
